module.exports = __webpack_public_path__ + "img/LogoPrincipal.48a79bb2.svg";